import z from "zod";

const HhMmScheme = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);

export const TimeRangeScheme = z.object({
  open: HhMmScheme,
  close: HhMmScheme,
});

const DayScheduleClosedScheme = z.object({
  closed: z.literal(true),
});

const DayScheduleOpenScheme = z.object({
  closed: z.literal(false),
  ranges: z.array(TimeRangeScheme).min(1),
});

export const DayScheduleScheme = z.discriminatedUnion("closed", [
  DayScheduleClosedScheme,
  DayScheduleOpenScheme,
]);

export const WeeklyOpeningHoursScheme = z.object({
  monday: DayScheduleScheme,
  tuesday: DayScheduleScheme,
  wednesday: DayScheduleScheme,
  thursday: DayScheduleScheme,
  friday: DayScheduleScheme,
  saturday: DayScheduleScheme,
  sunday: DayScheduleScheme,
});

const DateOverrideClosedScheme = z.object({
  type: z.literal("closed"),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  label: z.string().optional(),
});

const DateOverrideCustomScheme = z.object({
  type: z.literal("custom"),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  ranges: z.array(TimeRangeScheme).min(1),
  label: z.string().optional(),
});

export const DateOpeningOverrideScheme = z.discriminatedUnion("type", [
  DateOverrideClosedScheme,
  DateOverrideCustomScheme,
]);

export const OpeningHoursScheme = z.object({
  weekly: WeeklyOpeningHoursScheme,
  overrides: z.array(DateOpeningOverrideScheme),
});

export type TimeRange = z.infer<typeof TimeRangeScheme>;
export type DaySchedule = z.infer<typeof DayScheduleScheme>;
export type WeeklyOpeningHours = z.infer<typeof WeeklyOpeningHoursScheme>;
export type DateOpeningOverride = z.infer<typeof DateOpeningOverrideScheme>;
export type OpeningHours = z.infer<typeof OpeningHoursScheme>;
